export default __webpack_public_path__ + "static/media/bg-campaign-0.f6d00213.png";